import React from 'react';
import { Field } from './Field';

export const RestaurantInfoEditor = ({ info, onChange, lang }) => {
  const setBilingual = (field, which, value) => {
    const current = (info[field] && typeof info[field] === 'object') ? info[field] : { it: '', en: '' };
    onChange(field, { ...current, [which]: value });
  };
  const biIT = (field) => (typeof info[field] === 'object' ? (info[field]?.it || '') : (info[field] || ''));
  const biEN = (field) => (typeof info[field] === 'object' ? (info[field]?.en || '') : '');

  return (
    <section className="bg-white border-[1.5px] border-black rounded-[16px] p-5 md:p-6 max-w-4xl space-y-6">
      <div>
        <h2 className="font-display text-2xl md:text-3xl text-black mb-1">
          {lang === 'it' ? 'Informazioni del locale' : 'Place information'}
        </h2>
        <p className="text-xs text-black/60 mb-5">
          {lang === 'it'
            ? 'Tutto quello che appare in home e nel footer. Le descrizioni bilingue hanno un campo per IT e uno per EN.'
            : 'Everything shown in home and footer. Bilingual fields have both IT and EN versions.'}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <Field label={lang === 'it' ? 'Nome locale' : 'Place name'} value={info.name || ''} onChange={(v) => onChange('name', v)} />
          <Field label={lang === 'it' ? 'Indirizzo' : 'Address'} value={info.address || ''} onChange={(v) => onChange('address', v)} />
          <Field label={lang === 'it' ? 'Telefono' : 'Phone'} value={info.phone || ''} onChange={(v) => onChange('phone', v)} />
          <Field label={lang === 'it' ? 'Email (facoltativa)' : 'Email (optional)'} value={info.email || ''} onChange={(v) => onChange('email', v)} />
        </div>
      </div>

      <div>
        <h3 className="font-display text-xl text-black mb-2">
          {lang === 'it' ? 'Sottotitolo (sotto il logo)' : 'Tagline (under the logo)'}
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <Field label="Italiano" value={biIT('tagline')} onChange={(v) => setBilingual('tagline', 'it', v)} />
          <Field label="English" value={biEN('tagline')} onChange={(v) => setBilingual('tagline', 'en', v)} />
        </div>
      </div>

      <div>
        <h3 className="font-display text-xl text-black mb-2">
          {lang === 'it' ? 'Orari di apertura' : 'Opening hours'}
        </h3>
        <p className="text-xs text-black/60 mb-2">
          {lang === 'it'
            ? 'Scrivili come preferisci. Appaiono nel footer della home e nella versione stampata.'
            : 'Write them however you like. Shown in the home footer and the printable version.'}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <Field label="Italiano" value={biIT('hours')} onChange={(v) => setBilingual('hours', 'it', v)} textarea />
          <Field label="English" value={biEN('hours')} onChange={(v) => setBilingual('hours', 'en', v)} textarea />
        </div>
      </div>

      <div>
        <h3 className="font-display text-xl text-black mb-2">
          {lang === 'it' ? 'Prenotazioni & Social' : 'Reservations & Social'}
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <Field label={lang === 'it' ? 'Link "Prenota ora"' : '"Book now" link'} value={info.reserveUrl || ''} onChange={(v) => onChange('reserveUrl', v)} />
          <Field label={lang === 'it' ? 'Link "Scopri Il Ponticello"' : '"About" link'} value={info.websiteUrl || ''} onChange={(v) => onChange('websiteUrl', v)} />
          <Field label="Instagram URL" value={info.instagram || ''} onChange={(v) => onChange('instagram', v)} />
          <Field label="Facebook URL" value={info.facebook || ''} onChange={(v) => onChange('facebook', v)} />
        </div>
      </div>
    </section>
  );
};

export default RestaurantInfoEditor;
